<template>
  <div class="home">
    <new-header></new-header>
    <div class="right-customer-service-box" v-if="currentGlobalMenuIndex !== 8">
      <ul>
        <li v-for="(item, index) in customerBarData" :key="index" @click="clickCustomerServiceMenuHndler(index)">
          <img class="home-customer-service-item-icon" :src="item.icon" alt="">
          <p class="home-customer-service-item-text">{{ item.name }}</p>
        </li>
      </ul>
    </div>
    <router-view></router-view>
    <Footer v-if="currentGlobalMenuIndex !== 8" />
  </div>
</template>


<script>
import Header from './home/header.vue';
import NewHeader from './home/newHeader.vue';
import Footer from './home/footer.vue';
import { mapState } from 'vuex';
export default {
  name: 'Home',
  components: {
    Header,
    Footer,
    NewHeader
  },
  data() {
    return {
      customerBarData: [
        {
          icon: '/images/home/home_customer_service.png',
          name: '在线客服'
        },
        {
          icon: '/images/home/home_publish_product.png',
          name: '发布商品'
        },
        {
          icon: '/images/home/home_message.png',
          name: '消息中心'
        },
        {
          icon: '/images/home/home_business_cooperation.png',
          name: '商务合作'
        },
        {
          icon: '/images/home/home_download_app.png',
          name: '下载App'
        },
        {
          icon: '/images/home/home_back_to_top.png',
          name: '返回顶部'
        }
      ]
    }
  },
  methods: {
    clickCustomerServiceMenuHndler(index) {
      switch (index) {
        case 0: //在线客服
          if(this.userProfile.userId=='2001001'){
              this.$message.warning('不能跟自己聊天');
              return;
            }
          const currentItem = {
            type: 'customerService',  
            partnerId: '2001001',
            partnerNickname: '客服安琪',
          }
          const customerServiceRouteData = this.$router.resolve({
            name: 'chat',
            //如果需要传递数据
            query: { currentItem: JSON.stringify(currentItem) },
          })
          window.open(customerServiceRouteData.href, '_blank');
          break;
        case 1: //发布商品
          this.$router.push({ path: '/publishProduct' })
          this.$store.commit('home/setCurrentGlobalMenuIndex', 7);
          break;
        case 2: //消息中心
          if(!this.userProfile){
            this.$message.warning('请先登录');
            return;
          }
          const currentItem2 = {
            type: 'ordinaryMessage',//普通消息
            partnerId: '2001001',
            partnerNickname: '客服安琪',
          }
          const customerServiceRouteData2 = this.$router.resolve({
            name: 'chat',
            //如果需要传递数据
            query: { currentItem: JSON.stringify(currentItem2) },
          })
          window.open(customerServiceRouteData2.href, '_blank');
          break;
        case 3: //商务合作
          if(!this.userProfile){
            this.$message.warning('请先登录');
            return;
          }
          if(this.userProfile.userId=='2001002'){
            this.$message.warning('不能跟自己聊天');
            return;
          }
          const businessCooperationData = {
            type: 'businessCooperationMessage',//普通消息
            partnerId: '2001002',
            partnerNickname: '商务安琪',
          }
          const businessCooperationRouteData = this.$router.resolve({
            name: 'chat',
            //如果需要传递数据
            query: { currentItem: JSON.stringify(businessCooperationData) },
          })
          window.open(businessCooperationRouteData.href, '_blank');
          break;
        case 4: //下载App
          this.$router.push('/downloadApp', () => { });
          break;
        case 5: //返回顶部
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth' // 实现平滑滚动
          });
          break;
      }
    }
  },
  computed: {
    ...mapState({
      currentGlobalMenuIndex: state => state.home.currentGlobalMenuIndex,
      userProfile:state=>state.user.userProfile
    })
  }
}
</script>

<style lang="less" scoped>
.home {
  // width: 100vh;
  min-width: 1440px;
  //margin: 0 auto; // 水平居中，如果需要的话
  background: #F5F5F5;
  /*  关键：为 absolute 定位提供上下文 */
  min-height: 100vh;

  .right-customer-service-box {
    position: fixed;
    top: 225px;
    right: 22px;
    background: #FFFFFF;
    width: 78px;
    height: 468px;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    z-index: 999;

    ul {
      width: 78px;
      list-style-type: none;
      padding: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      cursor: default;
      user-select: none;

      li {
        list-style: none;
        width: 78px;
        height: 78px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .home-customer-service-item-icon {
          width: 18px;
          height: 18px;
          transition: all 0.3s ease-in-out;
        }

        .home-customer-service-item-text {
          margin-top: 10px;
          font-family: MicrosoftYaHei, MicrosoftYaHei;
          font-weight: bold;
          font-size: 12px;
          color: #666666;
          line-height: 12px;
          text-align: right;
          font-style: normal;
          transition: all 0.3s ease-in-out;
        }

        &:hover>p {
          font-size: 14px;
          color: #F02233;
        }

        &:hover>img {
          transform: scale(110%);
        }
      }
    }
  }
}
</style>